import { createUseStyles } from 'react-jss';

import { ViboTheme } from 'types/theme';

const useStyles = createUseStyles((theme: ViboTheme) => ({
  song: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    height: '48px',
    padding: '0 8px 0 12px',
    userSelect: 'none',
    position: 'relative',

    '&.highlighted': {
      '&:after': {
        ...theme.mixins.highlightedSongPseudo,
        border: `1px solid ${theme.palette.primary.main}`,
      },
    },

    '&.timelineSong': {
      height: '100%',

      //for gtm tracking propper target
      '& .songImage, & .songIndex, & .action .viboIcon, & .iconButton svg': {
        pointerEvents: 'none',
      },

      '& .songImage': {
        width: '40px',
        height: '40px',

        '@media screen and (min-width: 1441px)': {
          width: '48px',
          height: '48px',
        },
      },

      '& .flag .text': {
        display: 'none',
      },

      '& .stopPropagationWrapper': {
        display: 'flex',
      },
    },

    '& .creatorImage': {
      '& .gradient svg': {
        width: '10px',
        height: '10px',
        borderRadius: '0',
      },
    },

    '& .copy': {
      margin: '0 auto 0 5px',
    },

    '&:hover': {
      '& .songComment, & .songMoreTools, & .copy': {
        opacity: '1',
        pointerEvents: 'all',
      },

      '& .flag.unflagged': {
        '& .viboIcon': {
          color: theme.palette.primary.main,
        },
      },
    },

    '@media screen and (min-width: 1441px)': {
      height: '56px',
      padding: '0 8px 0 16px',
    },
  },

  isMustPlay: {
    backgroundColor: `${theme.palette.mustPlay.main}!important`,

    '&:hover': {
      backgroundColor: `${theme.palette.mustPlay.active}!important`,
    },
  },

  songImage: {
    cursor: 'default',
    width: '28px',
    height: '28px',

    '&:hover': {
      boxShadow: 'none',
    },

    '@media screen and (min-width: 1441px)': {
      width: '36px',
      height: '36px',
    },
  },

  withComment: {
    '& .songArtistNames': {
      maxWidth: '150px',

      '& .songName': {
        margin: '0 0 3px 0',

        '@media screen and (min-width: 1441px)': {
          margin: '0 0 5px 0',
        },
      },

      '@media screen and (min-width: 1441px)': {
        maxWidth: '200px',
      },

      '@media screen and (min-width: 1537px)': {
        maxWidth: '250px',
      },
    },

    '& .commentPreview': {
      display: 'none',

      '@media screen and (min-width: 1441px)': {
        display: 'block',
      },
    },
  },

  flag: {
    margin: '0 6px',

    '@media screen and (min-width: 1500px)': {
      margin: '0 8px',
    },
  },

  songIndex: {
    minWidth: '24px',
    textAlign: 'center',
    margin: '0 4px',
    color: theme.palette.text.secondary,

    '@media screen and (min-width: 1500px)': {
      minWidth: '28px',
    },
  },
}));

export default useStyles;
